// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"MobileNavigation_swiper-slide-active__P-bM-","navigation":"MobileNavigation_navigation__YlqGa"};